require('./brokerStocksContractStep3.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

const { BROKER_STOCK_CONTRACT_ID, messages: {BROKER_STOCK_CONTRACT_AND_GDPR} } = require('constants/operationTypes');
const {
    CCV_ACCOUNT,
    CHARGE_ACCOUNT_PREFIX,
    CONTRATO_PRESTACION_SERVICIOS_PERSONAS_FISICAS_FILE_EXTENSION,
    THIRD_STEP,
} = require('constants/index');

// @components
const BrokerStocksContractTAC  = require('components/broker/brokerStocksContract/brokerStocksContractTAC/brokerStocksContractTAC');
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const WebappRender = require('components/conditionalRender/webappRender');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ constants
const { BROKERS_STOCKS_CONTRACT_GDPR_PID } = require('constants/gdprPlacementIds');
const {
    BUY_STOCKS_CRF_INFO,
    BUY_STOCKS_W8_INFO,
} = require('constants/flagBasedFeatures');

//@commons
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');
const { OKLink } = require('commonsComponents/OKLink');

class BrokerStocksContractStep3 extends React.Component {
    constructor(props) {
        super(props);
        this.handleOnChangeTAC = this.handleOnChangeTAC.bind(this);
    }

    componentDidMount() {
        const { contrato_prestacion_servicios_personas_fisicas }= this.props;
        this.props.setTermsAndConditions(__CONTACT_CENTER__);
        this.props.requestPDFMerge({
            fileName: formatText('broker-stocksContractStepLegalDocumentFileName'),
            url: contrato_prestacion_servicios_personas_fisicas
        },[{
            id: CCV_ACCOUNT
        }]);
    }

    buildInterveners(rows) {
        let interveners = '';
        rows.map((row) => {
            interveners += row.get('name') + ' - ';
        });
        return interveners.slice(0, -3);
    }

    handleOnChangeTAC(tacOnChangeCallback) {
        this.props.setTermsAndConditions(tacOnChangeCallback.checked);
    }

    render(){
        const {
            finishReadingPrecontractualDocument,
            flagBasedFeatures,
            immAccount,
            immStocksContractForm,
            contractServicesIndividuals,
            contrato_prestacion_servicios_personas_fisicas,
        } = this.props;
        const consentElement = (<OKConsents placementId={BROKERS_STOCKS_CONTRACT_GDPR_PID} />);
        const contractTitle = formatText('broker-stocksContractStep2Title');
        const contractSubTitle = formatText('broker-stocksContractStep2SubTitle');
        const disclaimerError = immStocksContractForm.getIn(['errorFlags', 'termsAndConditions']);
        const operationParams = {
            originAccount: CHARGE_ACCOUNT_PREFIX + immAccount.getIn(['contract', 'product']) + immAccount.getIn(['contract', 'number'])
        };
        const preContractDocumentInfo = {
            preContractPdfLink: [
                {
                    fileName: formatText('broker-stocksContractStepLegalDocumentFileName'),
                    url: contrato_prestacion_servicios_personas_fisicas
                }
            ],
            preContractPdfFileName: CONTRATO_PRESTACION_SERVICIOS_PERSONAS_FISICAS_FILE_EXTENSION
        }
        let disclaimer;
        const link = formatText('broker-stocksContractCRFDisclaimerLinkUrl');
        const termsAndConditionChecked = immStocksContractForm.getIn(['steps', THIRD_STEP, 'termsAndConditions']);

        if (flagBasedFeatures.get(BUY_STOCKS_CRF_INFO) && flagBasedFeatures.get(BUY_STOCKS_W8_INFO)) {
            disclaimer = (
                <OKMessage type="important">
                    <FormattedText value="broker-stocksContractCRFText1" />
                    &nbsp;
                    <OKLink to={link} target="_blank" modifier="emphasize">
                        <FormattedText value="broker-stocksContractCRFDisclaimerLinkUrlText" />
                    </OKLink>
                    &nbsp;
                    <FormattedText value="broker-stocksContractCRFText2" />
                </OKMessage>
            );
        }

        return (
            <div className="stocks-contract-step3">
                <h2 className="stocks-contract-step3__title">{contractTitle}</h2>
                <p className="stocks-contract-step3__text">{contractSubTitle}</p>
                {consentElement}
                <WebappRender>
                    <div className="stocks-contract-step3__pdf-viewer-container">
                        <PreContractualDocumentViewer
                            preContractDocumentInfo={preContractDocumentInfo}
                            titleKey="preContractDocument_pdfTitlePrecontractual"
                            documentReadedCallback={finishReadingPrecontractualDocument}
                        />
                    </div>
                </WebappRender>
                <div className="stocks-contract-step3__tac">
                    <BrokerStocksContractTAC
                        onChange={this.handleOnChangeTAC}
                        disclaimerErrorState={disclaimerError}
                        disclaimerErrorMessage={formatText('broker-stocksContractCheckError')}
                        contractServicesIndividuals={contractServicesIndividuals}
                        disabled={!immStocksContractForm.get('precontractualDocumentReaded')}
                    />
                </div>
                {disclaimer}
                <hr />
                { termsAndConditionChecked &&
                    <div className="stocks-contract-step3__confirmation">
                        <GDPRSignaturePattern
                            operationType={BROKER_STOCK_CONTRACT_ID}
                            operationParams={operationParams}
                            multiOTPMessageCode={BROKER_STOCK_CONTRACT_AND_GDPR}
                            isWealth={true}
                        />
                    </div>
                }
            </div>
        );
    }
}

BrokerStocksContractStep3.propTypes = {
    flagBasedFeatures: PropTypes.object,
    immAccount: PropTypes.object.isRequired,
    immStocksContractForm: PropTypes.object.isRequired,
    setTermsAndConditions: PropTypes.func.isRequired,
    requestPDFMerge: PropTypes.func.isRequired,
    finishReadingPrecontractualDocument: PropTypes.func.isRequired,
    contractServicesIndividuals: PropTypes.string,
    contrato_prestacion_servicios_personas_fisicas: PropTypes.string
};

module.exports = BrokerStocksContractStep3;
